'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var common = {
    headerModuleHeight: '60px',
    headerModuleHeightSticky: '54px',
    oneHeaderModuleHeight: 56,
    oneHeaderModuleHeightWithS2CBanner: '100px',
    notificationBarTopHeight: {
        mobile: '100px',
        tablet: '148px',
        desktop: '50px',
        wideScreens: '60px',
    },
    genericDesktopPagePadding: '100px',
    desktopPagePadding: '15px',
    desktopSemiWideScreensPadding: '30px',
    desktopWideScreensPadding: '40px',
    tabletPagePadding: '30px',
    mobilePagePadding: '20px',
    buttonHeight: '44px',
    zIndexSkuDiverActionMenu: 200,
    zIndexShopToClubDOI: 103,
    zIndexShopToClubRegistration: 102,
    zIndexPopUpOverlay: 101,
    newHeaderTabsHeight: 46,
    smartBannerHeight: 86,
    microBannerHeight: 40,
    zindexUserSideNav: 60,
    zindexCategoryNav: 50,
    zindexHeaderClubTab: 40,
    zindexHeaderBarBanner: 41,
    zindexOneHeaderShadow: 40,
    zindexOneHeaderNavBar: 41,
    zindexOneHeader: 42,
    zindexSmartBanner: 43,
    zindexHeaderTopBar: 30,
    zIndexNavigationFlyout: 29,
    zIndexContentOverlay: 28,
    zIndexBelowContentOverlay: 27,
    zindexHeaderStickyIconBar: 20,
    zindexOverlayLoader: 15,
    zIndexDesktopDropDown: 11,
    zindexFloatingLabel: 10,
    zIndexHideClubTabRightShadow: 3,
    zIndexProductSpinner: 2,
    zIndexSliderArrows: 2,
    zIndexNavInfoSection: 1,
    zIndexProductGridBadges: 1,
    zIndexLooksOverlays: 1,
};

exports.default = common;
//# sourceMappingURL=index.js.map
